"use client";

import { liteClient as algoliasearch } from "algoliasearch/lite";
import { createMemoryCache } from "@algolia/client-common";
import { createContext, useContext, useMemo, type ReactNode } from "react";

type SearchClient = ReturnType<typeof algoliasearch>;

const AlgoliaClientContext = createContext<SearchClient | null>(null);

export function AlgoliaProvider({
  appId,
  searchApiKey,
  children,
}: {
  appId: string;
  searchApiKey: string;
  children: ReactNode;
}) {
  const client = useMemo(
    () =>
      algoliasearch(appId, searchApiKey, {
        responsesCache: createMemoryCache(),
      }),
    [appId, searchApiKey],
  );

  return (
    <AlgoliaClientContext.Provider value={client}>
      {children}
    </AlgoliaClientContext.Provider>
  );
}

export function useAlgoliaClient(): SearchClient {
  const client = useContext(AlgoliaClientContext);
  if (!client) {
    throw new Error("useAlgoliaClient must be used within <AlgoliaProvider>");
  }
  return client;
}
